import React, { type ReactNode, useEffect } from "react";
import { List, ListItem } from "@/features/shell/components/shared/List/List";
import type { AcceptOddsPreferences } from "hooks/firestore/user/usePreferences";

import * as styles from "@/features/betslip/components/overlays/QuickPreferences.module.scss";

type QuickPreferencesOptionsProps = {
  options: { value: AcceptOddsPreferences; display: ReactNode }[];
  selectedOption: AcceptOddsPreferences;
  setSelectedOption: (option: AcceptOddsPreferences) => void;
};

const Indicator = ({ active }: { active: boolean }) => (
  <div className={styles.optionIcon}>
    <div className={styles.radio} data-active={active} />
  </div>
);

export const Options = ({
  options,
  setSelectedOption,
  selectedOption,
}: QuickPreferencesOptionsProps) => {
  useEffect(() => {
    if (options.length > 1 && !selectedOption)
      setSelectedOption(options[0].value);
  }, [options]);

  return (
    <List>
      {options.map((option, index) => (
        <ListItem
          key={`pref-option-${index}`}
          onClick={() => setSelectedOption(option.value)}
          label={
            <div className={`${styles.flex} ${styles.alignCenter}`}>
              <Indicator active={selectedOption === option.value} />
              {option.display}
            </div>
          }
        />
      ))}
    </List>
  );
};
